import Alert from 'components/Alert'
import { Modal } from 'components/mobile/common/Modal'
import { Banner, Contract, Logout } from 'components/shard'
import { Color, Gap, Size } from 'const'
import { useServiceHook } from 'hooks'
import _ from 'lodash'
import React, { useEffect } from 'react'
import styled from 'styled-components'

export function Service() {
  const {
    services,
    servicesErrors,
    setServicesErrors,
    isServicesRequestingAPI,
    getServices,
    getCreditCardForList,
    modalDisplay,
    setModalDisplay,
    setContractId,
    close,
    link,
    getContractItems,
    PRODUCT_CLASSIFICATION,
  } = useServiceHook()

  useEffect(() => {
    getServices()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (services.length > 0) {
      getCreditCardForList()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [services.length])

  return (
    <React.Fragment>
      {isServicesRequestingAPI ? (
        <ServiceBlock>
          <Msg>ご利用・ご契約状況の確認中。</Msg>
        </ServiceBlock>
      ) : (
        <ServiceBlock>
          {servicesErrors.length > 0 && (
            <Alert
              type="error"
              message="エラー"
              description={servicesErrors.join('\n')}
              onClose={() => setServicesErrors([])}
            />
          )}
          {services.length > 0 ? (
            <React.Fragment>
              <Modal
                title="クレジットカードの登録"
                text="クレジットカードを登録ください。"
                caution="プリペイドやデビットの場合、申込直後に請求される場合があります。"
                display={modalDisplay}
                overlayOnClick={close}
                buttonOnClick={link}
              />
              <BoxLabel>契約履歴一覧</BoxLabel>
              <Announcement>{`クレジットカードの変更は契約中のプランをクリック↓\n※複数ご契約中の場合、一括変更されませんのでご注意下さい`}</Announcement>
              <BoxList
                services={services}
                setModalDisplay={setModalDisplay}
                setContractId={setContractId}
                link={link}
                {...{ getContractItems, PRODUCT_CLASSIFICATION }}
              ></BoxList>
            </React.Fragment>
          ) : (
            <Msg>現在、NINALご利用はありません。</Msg>
          )}
        </ServiceBlock>
      )}
      <Banner />
      <Logout />
    </React.Fragment>
  )
}

function BoxList({ services, setModalDisplay, setContractId, link, ...rest }) {
  return (
    <BoxListWrapper>
      {_.map(services, (service) => (
        <Contract
          contract={_.merge(service, rest)}
          setModalDisplay={setModalDisplay}
          setContractId={setContractId}
          link={link}
        />
      ))}
    </BoxListWrapper>
  )
}

const ServiceBlock = styled.div`
  position: relative;
  height: 100%;
  background-color: ${Color.BACKGROUND.BLOCK};
  margin: 20px 0 60px;
`
const BoxLabel = styled.div`
  font-size: ${Size.FONT.LG};
  padding: 30px 20px 14px;
  font-weight: 700;
`

const BoxListWrapper = styled.div`
  padding: 0 20px;
  display: grid;
  grid-template-columns: 1fr;
  gap: ${Gap.LG};
`

const Announcement = styled.div`
  color: ${Color.FONT.ANNOTATION_RED};
  font-size: ${Size.FONT.HEADLINE.MEDIUM};
  padding: 0 20px 24px;
  white-space: pre-line;
  font-weight: 700;
`
const Msg = styled.div`
  font-size: ${Size.FONT.MSG};
  text-align: center;
  padding: 40px 0px;
`

export default Service
